import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations, LANGS } from "@/i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "tf_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" && localStorage.getItem(STORAGE_KEY);
    return saved && translations[saved] ? saved : "hu";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
    const locale = lang === "hu" ? "hu_HU" : lang === "de" ? "de_DE" : "en_US";
    let el = document.querySelector('meta[property="og:locale"]');
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("property", "og:locale");
      document.head.appendChild(el);
    }
    el.setAttribute("content", locale);
  }, [lang]);

  const changeLang = useCallback((code) => {
    if (translations[code]) setLang(code);
  }, []);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
